export enum HeaderExcelEnum {
  patrimoine = 'patrimoine',
  composant = 'composant',
  caracteristique = 'caracteristique'
}
